/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The lock item details containing granular locks with failed ones, if any.
 */
export interface DeleteLockResponse { 
    /**
     * The lock item details with granular locks
     */
    lock_item: object;
    /**
     * The granular locks that are overridden and failed to be released
     */
    overridden_locks?: object;
}

